import { Application } from "@hotwired/stimulus"

import SearchController from "./search_controller"
import DropdownController from "./dropdown_controller"
import ModalController from "./modal_controller"
import FlashController from "./flash_controller"
import SectionNavController from "./section_nav_controller"
import HeroCarouselController from "./hero_carousel_controller"
import RoleSelectController from "./role_select_controller"
import SurgeonMapController from "./surgeon_map_controller"
import CookieConsentController from "./cookie_consent_controller"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Register controllers
application.register("search", SearchController)
application.register("dropdown", DropdownController)
application.register("modal", ModalController)
application.register("flash", FlashController)
application.register("section-nav", SectionNavController)
application.register("hero-carousel", HeroCarouselController)
application.register("role-select", RoleSelectController)
application.register("surgeon-map", SurgeonMapController)
application.register("cookie-consent", CookieConsentController)

export { application }
